"use client"

import { useEffect } from "react"
import { RelatedFields } from "../Component/FormBlock/service"
import { useExternalApiFormStore } from "./FormContext"
import { useRelatedFields } from "./RelatedFieldsInFromContext"

type LoadFormGlobalStoreProps = {
  additionalData: any
  relatedSelectFieldsDict: RelatedFields
}
export const LoadFormGlobalStore = ({
  additionalData,
  relatedSelectFieldsDict,
}: LoadFormGlobalStoreProps) => {
  const { setData, data } = useExternalApiFormStore()
  const { relatedFields, setRelatedFields } = useRelatedFields()

  useEffect(() => {
    if (!additionalData) {
      return
    }
    setData(additionalData)
  }, [data])

  useEffect(() => {
    if (!relatedSelectFieldsDict) {
      return
    }
    setRelatedFields(relatedSelectFieldsDict)
  }, [relatedFields])

  return null
}
